import React from 'react';
import Loadable from 'react-loading-overlay';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { WorkerForm } from '../WorkerForm';
import Row from '../../../../shared/components/Row';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { WorkerDetailTask } from './worker-detail/WorkerDetailTask';
import { WorkerDetailRequest } from './worker-detail/WorkerDetailRequest';
import { PsWorker } from '../../PsWorker';
import { WorkerFormValues } from '../WorkerFormValues';
import { connect } from 'react-redux';
import { CurrentUser } from '../../../../shared/model/CurrentUser';
import { WorkerUpdateTask } from './worker-update/WorkerUpdateTask';
import { WorkerUpdateRequest } from './worker-update/WorkerUpdateRequest';
import { bindActionCreators } from 'redux';
import * as navigationActions from '../../../../shared/utils/NavigationActions';
import DocumentsCard from '../../../../documents/components/DocumentsCard';
import CardMessages from '../../../../messages-notifications/messages/to-refactor/card/CardMessages';
import StateManager from '../../../../shared/utils/StateManager';

class WorkerUpdate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            worker: null,
            loading: false,
            workerInitialValues: WorkerFormValues.null(),
            refreshDocuments: false,
            lastSavedDocumentSchema: [],
            refreshQrToken: false,
            qrTokenLoading: false,
        };
    }

    componentDidMount() {
        this.getWorker();
    }

    handleSetRefreshDocuments = (refresh) => {
        this.setState({ refreshDocuments: refresh });
    };

    handleSetRefreshQrToken = (refresh) => {
        this.setState({ refreshQrToken: refresh });
    };

    handleTokenLoading = (loading) => {
        this.setState({ qrTokenLoading: loading });
    };

    render() {
        const {
            worker,
            loading,
            workerInitialValues,
            refreshDocuments,
            refreshQrToken,
            qrTokenLoading,
        } = this.state;

        if ( !worker ) return null;

        const { currentUser } = this.props;
        const workerId = worker.id();
        const workerCompanyId = worker.companyId();
        const initialValues = workerInitialValues.initialValues();

        return (
            <React.Fragment>
                <Row clearfix>
                    <WorkerForm
                        title={I18nUtils.tr('TR_EDITAR_TRABAJADOR')}
                        initialValues={initialValues}
                        onSubmit={this.updateWorker}
                        canWrite={
                            currentUser.isAdmin() || currentUser.isContractorsManager() || currentUser.isOutsourcesManager()
                        }
                        canSendInfoEmail={currentUser.isAdmin() || currentUser.isOutsourcesManager()}
                        contractorId={currentUser.contractorId()}
                        workerId={workerId}
                        handleSetRefreshQrToken={this.handleSetRefreshQrToken}
                        refreshQrToken={refreshQrToken}
                        handleTokenLoading={this.handleTokenLoading}
                        loading={loading || qrTokenLoading}
                    />
                </Row>
                <DocumentsCard
                    id={StateManager.DOC_WORKER_DETAIL_ID + workerId}
                    title={I18nUtils.tr('TR_DOCUMENTOS')}
                    workerId={workerId}
                    refreshDocuments={refreshDocuments}
                    handleSetRefreshDocuments={this.handleSetRefreshDocuments}
                />
                <Row clearfix>
                    <CardMessages
                        workerId={workerId}
                        companyId={workerCompanyId}
                        colWidth="col-md-12"
                        canAddMessage={!currentUser.isOutsourcesViewer()}
                        canResponseMessage={!currentUser.isOutsourcesViewer()}
                    />
                </Row>
            </React.Fragment>
        );
    }

    getWorker = () => {
        const { id, currentUser, appendBreadcrumb } = this.props;
        const request = new WorkerDetailRequest();

        request.setId(id);

        new WorkerDetailTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const worker = PsWorker.fromAPIWorker(res.data, currentUser);
                const workerInitialValues = WorkerFormValues.fromWorker(worker, currentUser.contractorId());
                appendBreadcrumb(worker);
                const lastSavedDocumentSchema = workerInitialValues.initialValues().contractorSchema;
                this.setState({ worker, workerInitialValues, lastSavedDocumentSchema });
            })
            .onFail((error) => {
                Alert.error(error);
                this.setState({ loading: false });
            })
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    updateWorker = (values) => {
        const {
            worker,
            workerInitialValues,
            lastSavedDocumentSchema,
        } = this.state;

        // comprobación de si ha cambiado un esquema para refrescar el listado de documentos
        let needsRefreshDocuments = false;
        const initialValues = workerInitialValues.initialValues();
        initialValues.contractorSchema.forEach((contractorSchema, index) => {
            if ( ( !needsRefreshDocuments && values.contractorSchema[index] &&
                    values.contractorSchema[index].length !== contractorSchema.length ) ||
                values.contractorSchema[index] !== contractorSchema ) {
                needsRefreshDocuments = true;
            }
        });

        if ( lastSavedDocumentSchema.length !== 0 && values.contractorSchema.length === 0 ) {
            values = {
                ...values,
                contractorSchema: [{ value: null }],
            };
        }

        this.setState({ loading: true });
        const request = new WorkerUpdateRequest(values, worker);
        new WorkerUpdateTask(request)
            .onSuccess(() => {
                this.setState({ loading: false });
                Alert.success(I18nUtils.tr('TR_TRABAJADOR_EDITADO_CORRECTAMENTE'));
                if ( needsRefreshDocuments ) {
                    this.handleSetRefreshDocuments(true);
                }
                this.setState({ lastSavedDocumentSchema: values.contractorSchema });
                this.handleSetRefreshQrToken(true);
            })
            .onFail((error) => {
                Alert.error(error);
                this.setState({ loading: false });
            })
            .execute();
    };
}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

const mapDispatchToProps = (dispatch) => ( { navigation: bindActionCreators(navigationActions, dispatch) } );

export const WorkerUpdateContent = connect(mapStateToProps, mapDispatchToProps)(WorkerUpdate);

WorkerUpdateContent.propTypes = {
    id: PropTypes.number.isRequired,
    appendBreadcrumb: PropTypes.func,
};

WorkerUpdateContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/update/WorkerUpdateContent.jsx